(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSitePartKeySearch', PublicSitePartKeySearch);

    PublicSitePartKeySearch.$inject = ['$resource'];

    function PublicSitePartKeySearch($resource) {
        var resourceUrl =  'api/_search/public-site-part-keys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
